import {tokens, view} from '@sail/ui';
import {animate, AnimatePresence} from '@sail/engine';
import {LightCard} from '@stripe-internal/conversations-ui';
import {FormContainer} from '../../helpers/FormContainer';

interface FormStepProps {
  children: React.ReactNode;
  isFormComplete?: boolean;
}

export const FormStep = ({children, isFormComplete = false}: FormStepProps) => {
  return (
    <AnimatePresence>
      <view.div
        css={{
          marginTop: tokens.space.small,
          marginBottom: tokens.space.small,
        }}
        uses={[
          animate.in({
            duration: 1000,
            opacity: 0,
            easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
          }),
        ]}
      >
        {isFormComplete ? (
          <LightCard>
            <view.div data-testid="ideal-inquiry-form">{children}</view.div>
          </LightCard>
        ) : (
          <FormContainer>
            <view.div data-testid="ideal-inquiry-form">{children}</view.div>
          </FormContainer>
        )}
      </view.div>
    </AnimatePresence>
  );
};
